import { setResources } from "./bootstrapResources";
import serverReference from "./serverReference-pt-BR.json";
import resources from "./translations-pt-BR.json";

setResources(resources, serverReference);